/* Local navigation surfaces only. Product links and the collection remain ordinary URLs. */
(() => {
  const key = '__OE_HEADER_NAV__';
  if (window[key]) { window[key].mount(); return; }
  let currentRoot = null, dispose = null;
  function mount() {
  const root = document.querySelector('[data-oe-header="clarity-v3"]');
  if (root === currentRoot) return;
  dispose?.();
  if (!root) return;
  currentRoot = root;
  root.dataset.initialized = 'true';
  const controller = new AbortController();
  const previousScrollPadding = document.documentElement.style.scrollPaddingTop;
  const listen = (target, type, handler, options = {}) => target?.addEventListener(type, handler, {...(typeof options === 'boolean' ? {capture:options} : options), signal: controller.signal});

  // Independent viewport layer: never composite the bottom dock inside the
  // scrolling/sticky header. Move existing nodes; preserve all handlers/counts.
  const dockHost = document.createElement('div');
  dockHost.className = 'oe-h2 oe-app-dock-root';
  dockHost.setAttribute('data-oe-dock-root', '');
  document.body.append(dockHost);
  const allControls = selector => [...root.querySelectorAll(selector), ...dockHost.querySelectorAll(selector)];
  // Safari can mark programmatic dialog focus as focus-visible after a tap.
  // Keep focus semantics, but draw focus rings only for keyboard interaction.
  root.dataset.input = dockHost.dataset.input = 'pointer';
  listen(document, 'pointerdown', () => { root.dataset.input = dockHost.dataset.input = 'pointer'; }, true);
  listen(document, 'keydown', event => {
    if (event.key === 'Tab' || event.key.startsWith('Arrow')) root.dataset.input = dockHost.dataset.input = 'keyboard';
  }, true);
  const hasKeyboardFocus = () => root.dataset.input === 'keyboard' && root.contains(document.activeElement) && document.activeElement.matches(':focus-visible');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = matchMedia('(max-width: 1179px)');
  // Reserve space after the footer so the final links can scroll above the dock.
  const clearance = document.createElement('div');
  {
    clearance.className = 'oe-h4-dock-clearance';
    clearance.setAttribute('aria-hidden', 'true');
    document.body.append(clearance);
  }
  // A virtual keyboard owns the thumb area while an input is being edited.
  function updateDockKeyboard() {
    const editable = document.activeElement?.matches('input:not([type="button"]):not([type="submit"]):not([type="checkbox"]):not([type="radio"]),textarea,[contenteditable="true"]');
    root.dataset.dockKeyboard = dockHost.dataset.dockKeyboard = String(!!(mobile.matches && editable && window.visualViewport && window.innerHeight - window.visualViewport.height > 150));
  }
  listen(window.visualViewport, 'resize', updateDockKeyboard);
  listen(document, 'focusin', updateDockKeyboard);
  listen(document, 'focusout', () => requestAnimationFrame(updateDockKeyboard));
  listen(mobile, 'change', updateDockKeyboard);
  const states = new Map([...root.querySelectorAll('dialog')].map(dialog => [dialog, {
    sheet: dialog.querySelector('.oe-h3-sheet'), motion: null, details: [], revision: 0, closing: false, opener: null
  }]));
  let savedOverflow = null, activeDialog = null, cartDialog = null;
  function isScrollLocked() {
    if (activeDialog || document.body.style.position === 'fixed') return true;
    // The cart mounts independently. Cache its dialog after it becomes available.
    if (!cartDialog?.isConnected) cartDialog = document.querySelector('#oe-cart-root #drawer');
    return !!cartDialog?.open;
  }
  const recessed = [...root.querySelectorAll('.oe-h3-tools,.oe-h2-promise,.oe-h2-account,.oe-h2-desktop,.oe-h2-brand')];
  const headerSurface = root.querySelector('.oe-h4-header-surface');
  root.querySelector('.oe-h4-desktop-background')?.remove();
  const desktopBackground = document.createElement('div');
  desktopBackground.className = 'oe-h4-desktop-background';
  desktopBackground.setAttribute('aria-hidden', 'true');
  root.prepend(desktopBackground);
  const topCart = root.querySelector('#cart-icon-bubble');
  const dockCart = root.querySelector('#oe-cart-dock');
  const headerSection = root.closest('.shopify-section') || root.parentElement;
  let headerHeight = root.offsetHeight, mobileState = 'flow', mobileAnimated = false;
  headerSection.dataset.oeMobileHeader = mobileState;
  // Be Yours: first scroll out in document flow; only become sticky below
  // the original header. Measure document bounds outside the scroll handler.
  let headerDocumentTop = headerSection.getBoundingClientRect().top + window.scrollY;
  let maxScroll = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
  const scrollY = () => Math.max(0, Math.min(maxScroll, window.scrollY));
  function measureScrollLimit() {
    // A fixed-body cart lock reduces document.scrollHeight to the viewport.
    // Safari toolbar/keyboard resizes must not cache that temporary zero range.
    if (!isScrollLocked()) maxScroll = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
  }
  const pageObserver = new ResizeObserver(measureScrollLimit);
  pageObserver.observe(document.body);
  listen(window, 'resize', measureScrollLimit, {passive:true});
  let minimal = false, previousY = scrollY(), upwardTravel = 0, hasDocumentScrolled = false;
  let scrollFrame = 0, returnFrame = 0, headerTravel = 0, navigationInert = false, cartDocked = false;
  function syncCartLocation() {
    const docked = mobile.matches;
    if (docked !== cartDocked || !root.hasAttribute('data-cart-docked')) {
      cartDocked = docked;
      root.dataset.cartDocked = String(docked);
      dockCart.inert = !docked;
      dockCart.setAttribute('aria-hidden', String(!docked));
    }
    const hideTop = mobile.matches && mobileState === 'hidden';
    if (headerSurface.inert !== hideTop) headerSurface.inert = hideTop;
    if (topCart.inert !== hideTop) topCart.inert = hideTop;
  }
  syncCartLocation();
  function setMobileState(next) {
    const animate = next === 'flow' ? false : mobileAnimated || next === 'revealed';
    if (animate !== mobileAnimated) {
      mobileAnimated = animate;
      headerSurface.classList.toggle('oe-native-animate', animate);
    }
    if (next !== mobileState) {
      mobileState = next;
      headerSection.dataset.oeMobileHeader = next;
    }
    const receded = next === 'hidden';
    if (minimal !== receded) {
      minimal = receded;
      root.classList.toggle('is-scroll-minimal', receded);
    }
    syncCartLocation();
  }
  function paintTravel(distance) {
    const next = Math.max(0, Math.min(headerHeight, distance));
    if (Math.abs(next - headerTravel) > .01) {
      headerTravel = next;
      // Write only to the painted layers, not an inherited variable on the
      // entire header/dialog tree. The cart material is scoped to the cart.
      if (!mobile.matches) {
        const transform = `translate3d(0,${-headerTravel}px,0)`;
        const opacity = String(1 - headerTravel / Math.max(1, headerHeight));
        desktopBackground.style.transform = transform;
        recessed.forEach(el => { el.style.transform = transform;el.style.opacity = opacity; });
      }
      topCart.style.setProperty('--oe-cart-glass', String(Math.min(1, headerTravel / 48)));
    }
    const inert = headerTravel >= headerHeight - .5;
    if (inert !== navigationInert) {
      navigationInert = inert;
      recessed.forEach(el => { el.inert = inert; });
    }
    syncCartLocation();
  }
  function stopReturn() {
    if (returnFrame) cancelAnimationFrame(returnFrame);
    returnFrame = 0;
  }
  function returnHeader() {
    if (reduced.matches) { stopReturn();paintTravel(0);return; }
    if (returnFrame || headerTravel === 0) return;
    let lastTime = performance.now();
    function step(time) {
      returnFrame = 0;
      const dt = Math.min(50, time - lastTime);lastTime = time;
      const next = headerTravel * Math.exp(-dt / 48);
      paintTravel(next < .5 ? 0 : next);
      if (headerTravel > 0) returnFrame = requestAnimationFrame(step);
    }
    returnFrame = requestAnimationFrame(step);
  }
  function setMinimal(value) {
    if (mobile.matches) {
      setMobileState(value ? 'hidden' : scrollY() <= headerDocumentTop + 1 ? 'flow' : 'revealed');
      return;
    }
    if (minimal !== value) {
      minimal = value;
      root.classList.toggle('is-scroll-minimal', value);
    }
    if (!value) { if (hasKeyboardFocus()) { stopReturn();paintTravel(0); } else returnHeader(); }
  }
  function updateScroll() {
    scrollFrame = 0;
    // Lock/unlock can synthesize scrollY=0 and restore it afterward. Neither is
    // a user direction change; keep the last genuine document position.
    if (isScrollLocked()) return;
    const y = scrollY(), delta = y - previousY;
    previousY = y;
    if (delta !== 0) hasDocumentScrolled = true;
    if (activeDialog || hasKeyboardFocus() || y <= 1) {
      upwardTravel = 0;setMinimal(false);return;
    }
    if (delta < 0) upwardTravel -= delta;
    else if (delta > 0) upwardTravel = 0;
    if (mobile.matches) {
      // Native Be Yours states: no per-frame transform writes or JS animation.
      // Returning to the document-flow range needs no separate hide animation.
      if (y <= headerDocumentTop + 1) setMobileState('flow');
      else if (y > headerDocumentTop + headerHeight) {
        if (delta > 0) setMobileState('hidden');
        else if (delta < 0) setMobileState('revealed');
      } else if (mobileState === 'hidden') setMobileState('flow');
      return;
    }
    if (delta > 0) {
      // Reverse from the last painted position, never from a stale animation target.
      stopReturn();setMinimal(true);paintTravel(headerTravel + delta);
    } else if (upwardTravel >= 12) setMinimal(false);
  }
  listen(window, 'scroll', () => {
    if (mobile.matches) updateScroll();
    else if (!scrollFrame) scrollFrame = requestAnimationFrame(updateScroll);
  }, {passive:true});
  listen(root, 'focusin', () => {
    if (hasKeyboardFocus()) setMinimal(false);
  });
  listen(mobile, 'change', () => {
    stopReturn();cancelAnimationFrame(scrollFrame);scrollFrame = 0;
    setMobileState('flow');headerSurface.style.removeProperty('transform');
    if (mobile.matches) {
      recessed.forEach(el => { el.style.removeProperty('transform');el.style.removeProperty('opacity'); });
      desktopBackground.style.removeProperty('transform');
    }
    paintTravel(0);setMinimal(false);syncCartLocation();
    previousY = scrollY();upwardTravel = 0;
  });
  listen(window, 'pageshow', event => {
    // Initial pageshow can arrive after images load, long after scrolling has
    // started. Only BFCache restoration may reset an already interactive header.
    if (!event.persisted && hasDocumentScrolled) return;
    if (isScrollLocked()) return;
    stopReturn();previousY = scrollY();
    const receded = previousY > 1 && !activeDialog && !hasKeyboardFocus();
    if (mobile.matches) { setMobileState(receded && previousY > headerDocumentTop + headerHeight ? 'hidden' : 'flow'); }
    else { minimal = receded;root.classList.toggle('is-scroll-minimal', receded);paintTravel(receded ? headerHeight : 0); }
  });

  function resumeAfterOverlay() {
    if (isScrollLocked()) return;
    measureScrollLimit();
    previousY = scrollY();upwardTravel = 0;
    if (mobile.matches) {
      if (previousY <= headerDocumentTop + 1) setMobileState('flow');
      else if (mobileState === 'flow' && previousY > headerDocumentTop + headerHeight) setMobileState('hidden');
    }
  }
  // Native close fires after the cart's synchronous unlock/scroll restoration.
  // Our own dialogs resume in restore(), including switches/reversed closes.
  listen(document, 'close', event => {
    if (event.target === cartDialog || event.target.matches?.('#oe-cart-root #drawer')) resumeAfterOverlay();
  }, true);

  function expanded(dialog, value) {
    allControls(`[data-open="${dialog.id}"]`).forEach(el => el.setAttribute('aria-expanded', String(value)));
  }
  function stop(state) {
    ++state.revision;
    state.motion?.cancel();state.motion = null;
    state.details.forEach(animation => animation.cancel());state.details = [];
  }
  function restore(dialog) {
    if (dialog.open) return;
    const state = states.get(dialog);
    stop(state);expanded(dialog, false);
    dialog.classList.remove('is-closing');state.closing = false;
    if (activeDialog !== dialog) return;
    activeDialog = null;
    if (savedOverflow !== null) {document.body.style.overflow = savedOverflow;savedOverflow = null;}
    resumeAfterOverlay();
    const opener = state.opener;
    const visible = opener?.isConnected && opener.getClientRects().length && !opener.closest('[inert],dialog:not([open])');
    const fallback = [...allControls(`[data-open="${dialog.id}"]`)].find(el => el.getClientRects().length);
    (visible ? opener : fallback)?.focus({preventScroll: true});
  }
  function endClose(dialog) {dialog.close();restore(dialog);}
  function animate(dialog, opening, pointer) {
    const state = states.get(dialog), sheet = state.sheet;
    const current = state.motion ? {opacity: getComputedStyle(sheet).opacity, transform: getComputedStyle(sheet).transform} : null;
    stop(state);const token = state.revision;
    if (!pointer || reduced.matches || !sheet.animate) {if (!opening) endClose(dialog);return;}
    const catalogue = dialog.id === 'oe-h3-catalogue';
    const hidden = {opacity: 0, transform: catalogue
      ? (mobile.matches ? 'translateY(38px) scale(.985)' : 'translateY(-26px) scale(.985)')
      : (mobile.matches ? 'translateY(-22px)' : 'translateX(-24px)')};
    const visible = {opacity: 1, transform: 'translate(0, 0) scale(1)'};
    state.motion = sheet.animate([current || (opening ? hidden : visible), opening ? visible : hidden], {
      duration: opening ? (catalogue ? 280 : 260) : 170,
      easing: catalogue ? 'cubic-bezier(0.32, 0.72, 0, 1)' : 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'both'
    });
    if (opening && catalogue && !current) {
      state.details = [...dialog.querySelectorAll('[data-catalogue-card]')].map((card, i) => card.animate([
        {opacity: 0, transform: 'translateY(10px)'}, {opacity: 1, transform: 'translateY(0)'}
      ], {duration: 210, delay: i * 22, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'backwards'}));
    }
    state.motion.finished.then(() => {
      if (controller.signal.aborted || token !== state.revision) return;
      state.motion.cancel();state.motion = null;
      if (!opening) endClose(dialog);
    }).catch(() => {});
  }
  function open(dialog, opener, pointer) {
    const state = states.get(dialog);
    if (!state || (dialog.open && !state.closing)) return;
    // Keep the single scroll lock while switching surfaces; an old close event cannot steal focus.
    activeDialog = dialog;
    for (const [other, otherState] of states) if (other !== dialog && other.open) {
      stop(otherState);other.close();expanded(other, false);other.classList.remove('is-closing');otherState.closing = false;
    }
    setMinimal(false);
    state.opener = opener;state.closing = false;dialog.classList.remove('is-closing');
    dialog.dataset.motion = pointer && !reduced.matches ? 'pointer' : 'none';
    if (savedOverflow === null) {savedOverflow = document.body.style.overflow;document.body.style.overflow = 'hidden';}
    if (!dialog.open) dialog.showModal();
    expanded(dialog, true);
    dialog.querySelector('.oe-h2-dialog-scroll').scrollTop = 0;
    const initialFocus = pointer ? dialog.querySelector('h2') : dialog.querySelector('[data-close]');
    initialFocus?.focus({preventScroll: true});
    animate(dialog, true, pointer);
  }
  function close(dialog, pointer) {
    const state = states.get(dialog);
    if (!dialog.open || (state.closing && pointer)) return;
    state.closing = true;dialog.dataset.motion = pointer && !reduced.matches ? 'pointer' : 'none';
    dialog.classList.add('is-closing');animate(dialog, false, pointer);
  }
  allControls('[data-open]').forEach(trigger => {
    listen(trigger, 'click', event => {
      if (event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const dialog = root.querySelector('#' + trigger.dataset.open);
      if (!states.has(dialog)) return;
      event.preventDefault();open(dialog, trigger, event.detail > 0 && root.dataset.input === 'pointer');
    });
  });
  for (const [dialog] of states) {
    listen(dialog.querySelector('[data-close]'), 'click', event => close(dialog, event.detail > 0));
    listen(dialog, 'cancel', event => {event.preventDefault();close(dialog, false);});
    listen(dialog, 'close', () => restore(dialog));
    listen(dialog, 'keydown', event => {
      if (event.key !== 'Tab') return;
      const items = [...dialog.querySelectorAll('a[href],button:not(:disabled),[tabindex="0"]')]
        .filter(el => el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
      if (!items.length) return;
      if (event.shiftKey && document.activeElement === items[0]) {event.preventDefault();items.at(-1).focus();}
      else if (!event.shiftKey && document.activeElement === items.at(-1)) {event.preventDefault();items[0].focus();}
    });
    let downOutside = false;
    function outside(event) {const r = dialog.getBoundingClientRect();return event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom;}
    listen(dialog, 'pointerdown', event => {downOutside = event.target === dialog && outside(event);});
    listen(dialog, 'pointerup', event => {if (downOutside && event.target === dialog && outside(event)) close(dialog, true);downOutside = false;});
  }
  listen(reduced, 'change', () => {
    if (reduced.matches) {
      if (returnFrame) { stopReturn();paintTravel(0); }
      for (const [dialog, state] of states) if (state.motion || state.details.length) animate(dialog, !state.closing, false);
    }
  });
  const headerObserver = new ResizeObserver(entries => {
    const height = entries[0].borderBoxSize?.[0]?.blockSize || root.offsetHeight;
    const wasHidden = headerTravel >= headerHeight - .5;
    headerHeight = height;
    if (mobileState === 'flow' && !isScrollLocked()) headerDocumentTop = headerSection.getBoundingClientRect().top + window.scrollY;
    if (!mobile.matches) paintTravel(wasHidden ? height : headerTravel);
    document.documentElement.style.setProperty('--oe-header-height', height + 'px');
    document.documentElement.style.scrollPaddingTop = (height + 12) + 'px';
  });
  headerObserver.observe(root);
  const dock = root.querySelector('.oe-h4-dock');
  dockHost.append(dock);
  dispose = () => {
    controller.abort();stopReturn();cancelAnimationFrame(scrollFrame);
    headerObserver.disconnect();pageObserver.disconnect();
    for (const [dialog, state] of states) { stop(state);if (dialog.open) dialog.close(); }
    if (savedOverflow !== null) document.body.style.overflow = savedOverflow;
    dockHost.remove();clearance.remove();desktopBackground.remove();
    delete headerSection.dataset.oeMobileHeader;
    headerSurface.classList.remove('oe-native-animate');
    document.documentElement.style.removeProperty('--oe-header-height');
    document.documentElement.style.scrollPaddingTop = previousScrollPadding;
    delete root.dataset.initialized;
    currentRoot = null;dispose = null;
  };
  }
  window[key] = {mount};
  document.addEventListener('shopify:section:load', mount);
  document.addEventListener('shopify:section:unload', event => {
    if (currentRoot && event.target.contains(currentRoot)) dispose?.();
  });
  mount();
})();
